import { FunctionComponent } from 'react';

export function withContext<T extends object>(
  Component: FunctionComponent<T>,
  Context: FunctionComponent<any>,
) {
  return (props: T) => (
    <Context>
      <Component {...props} />
    </Context>
  );
}
